export default class ResponseInformationRequest {
  id: number;
  description: string;
  status_id: number;
  citizen_request_id: number;
  attachments: ReponseInformationRequestAttachment[];

  constructor(values: ReponseInformationRequestConstructValues) {
    (this.id = values.id),
      (this.description = values.description),
      (this.citizen_request_id = values.citizen_request_id),
      (this.attachments = values.attachments);
    this.status_id = values.status_id;
  }
}

export interface ReponseInformationRequestConstructValues {
  id: number;
  description: string;
  status_id: number;
  citizen_request_id: number;
  attachments: ReponseInformationRequestAttachment[];
}

export interface ReponseInformationRequestAttachment {
  id: number;
  name: string;
  download_url: string;
}
